module.exports = __webpack_public_path__ + "static/fonts/OswaldDemiBoldItalic.1681f3f.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/OswaldDemiBoldItalic.ttf
// module id = 977
// module chunks = 113